/**
 * Hook useUndoToast : exécute une action puis affiche un toast « Annuler » pendant 10 s
 * (principe UX : annulation plutôt que confirmation pour les entrées/sorties).
 */
import { toast } from 'sonner';
import { UNDO_DELAY_MS } from '../constants';

/**
 * @returns {{ notify: (message: string, onUndo: () => Promise<void>|void) => void }}
 */
export function useUndoToast() {
  const notify = (message, onUndo) => {
    toast(message, {
      duration: UNDO_DELAY_MS,
      action: {
        label: 'Annuler',
        onClick: async () => {
          try {
            await onUndo();
            toast.success('Entrée annulée');
          } catch {
            toast.error("Impossible d'annuler");
          }
        },
      },
    });
  };
  return { notify };
}
